module.exports = __webpack_public_path__ + "img/logo.ee60f20c.png";